import {Eye} from 'core/api/prescription'
import {ICreateSubject} from 'core/api/study_coordinator'
import {IAction, IFormSubmitAction, IPayloadAction} from 'core/store'
import * as actions from './actionTypes'
import {ISubject} from './model'

export interface IActionAddSubjectRequest extends
  IFormSubmitAction<typeof actions.ADD_SUBJECT_REQUEST, ICreateSubject> {}

export const addSubjectRequest = (payload: ICreateSubject, formName: string): IActionAddSubjectRequest => ({
  type: actions.ADD_SUBJECT_REQUEST,
  payload,
  form: formName,
})

export interface IActionSetSubjects extends IPayloadAction<typeof actions.SET_SUBJECTS, ISubject[]> {}
export const setSubjects = (payload: ISubject[]): IActionSetSubjects => ({
  type: actions.SET_SUBJECTS,
  payload,
})

export interface IActionClearSubjects extends IAction<typeof actions.CLEAR_SUBJECTS> {}

export const clearSubjects = (): IActionClearSubjects => ({
  type: actions.CLEAR_SUBJECTS,
})

export interface IActionGetSubjectsRequest extends IAction<typeof actions.GET_SUBJECTS_REQUEST> {}

export const getSubjectsRequest = (): IActionGetSubjectsRequest => ({
  type: actions.GET_SUBJECTS_REQUEST,
})

export interface IActionSetIsFetching extends IAction<typeof actions.SET_IS_FETCHING_SUBJECTS> {}

export const setIsFetchingSubjects = (): IActionSetIsFetching => ({
  type: actions.SET_IS_FETCHING_SUBJECTS,
})

export interface IActionResetIsFetchingSubjects extends IAction<typeof actions.RESET_IS_FETCHING_SUBJECTS> {}

export const resetIsFetchingSubjects = (): IActionResetIsFetchingSubjects => ({
  type: actions.RESET_IS_FETCHING_SUBJECTS,
})

export interface IActionSetIsConfirmActive extends IAction<typeof actions.SET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE> {}

export const setIsSubjectActivationConfirmActive = (): IActionSetIsConfirmActive => ({
  type: actions.SET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE,
})

export interface IActionResetIsSubjectActivationConfirmActive extends
  IAction<typeof actions.RESET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE> {}

export const resetIsSubjectActivationConfirmActive = (): IActionResetIsSubjectActivationConfirmActive => ({
  type: actions.RESET_IS_SUBJECT_ACTIVATION_CONFIRM_ACTIVE,
})

interface IActionDeactivateSubjectRequestPayload {
  subjectIdentifier: string
  reason: string
}
export interface IActionDeactivateSubjectRequest extends
  IPayloadAction<typeof actions.DEACTIVATE_SUBJECT_REQUEST, IActionDeactivateSubjectRequestPayload> {}

export const deactivateSubjectRequest = (
  payload: IActionDeactivateSubjectRequestPayload,
): IActionDeactivateSubjectRequest => ({
  type: actions.DEACTIVATE_SUBJECT_REQUEST,
  payload,
})

interface IActionReactivateSubjectRequestPayload {
  subjectIdentifier: string
}
export interface IActionReactivateSubjectRequest extends
  IPayloadAction<typeof actions.REACTIVATE_SUBJECT_REQUEST, IActionReactivateSubjectRequestPayload> {}

export const reactivateSubjectRequest = (
  payload: IActionReactivateSubjectRequestPayload,
): IActionReactivateSubjectRequest => ({
  type: actions.REACTIVATE_SUBJECT_REQUEST,
  payload,
})

interface IActionCreatePrescriptionRequestPayload {
  subjectIdentifier: string
  amblyopicEye: Eye
  prescriptionTemplateKey: string
}

export interface IActionCreatePrescriptionRequest<T extends string> extends
  IFormSubmitAction<T, IActionCreatePrescriptionRequestPayload> {}

export interface IActionCreateNewPrescriptionRequest extends
  IActionCreatePrescriptionRequest<typeof actions.CREATE_PRESCRIPTION_REQUEST> {}

export const createPrescriptionRequest = (
  payload: IActionCreatePrescriptionRequestPayload,
  formName: string,
): IActionCreateNewPrescriptionRequest => ({
  type: actions.CREATE_PRESCRIPTION_REQUEST,
  payload,
  form: formName,
})

export interface IActionUpdatePrescriptionRequest extends
  IActionCreatePrescriptionRequest<typeof actions.UPDATE_PRESCRIPTION_REQUEST> {}

export const updatePrescriptionRequest = (
  payload: IActionCreatePrescriptionRequestPayload,
  formName: string,
): IActionUpdatePrescriptionRequest => ({
  type: actions.UPDATE_PRESCRIPTION_REQUEST,
  payload,
  form: formName,
})



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/subjects/actions.ts